import React from "react";
import { Company } from "../schemas/auth";

interface CompanyCardProps {
  company: Company;
  onSelect: (company: Company) => void;
  disabled?: boolean;
}

export default function CompanyCard({
  company,
  onSelect,
  disabled = false,
}: CompanyCardProps) {
  const displayName = company.company_name ?? company.portal_uid;

  // App-driven discovery may offer a company the user has no account in yet.
  // Tell them what happens on selection: auto-provision, or no access.
  const willProvision =
    company.requires_provisioning && company.auto_provisioning_enabled;
  const noAccess =
    company.requires_provisioning && !company.auto_provisioning_enabled;

  return (
    <button
      type="button"
      className="company-card card w-100 text-start border mb-3"
      onClick={() => onSelect(company)}
      disabled={disabled}
      aria-label={`Select ${displayName}`}
    >
      <div className="card-body d-flex align-items-center gap-3 py-3 px-4">
        <div className="company-card__icon rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
          <span className="fw-bold text-white fs-5" aria-hidden="true">
            {displayName.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="overflow-hidden">
          <div className="fw-semibold text-dark text-truncate">
            {displayName}
          </div>
          <div className="text-muted small text-truncate">
            {company.portal_uid}
          </div>
          {willProvision && (
            <div className="text-success small text-truncate">
              You&apos;ll be set up automatically
            </div>
          )}
          {noAccess && (
            <div className="text-muted small text-truncate">
              No access — contact your administrator
            </div>
          )}
        </div>
        <div className="ms-auto text-muted">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
    </button>
  );
}
